'use client'

import { cn } from '@src/utils/tailwind'

interface PriceProps {
  oldPrice?: number
  oldPriceSuffix?: string
  newPrice: number
  newPriceSuffix?: string
  size?: 'small' | 'large'
  currencySymbol: string
  symbolPosition: 'before' | 'after'
}

export const Price = (props: PriceProps) => {
  const {
    oldPrice,
    oldPriceSuffix,
    newPrice,
    newPriceSuffix,
    size,
    currencySymbol,
    symbolPosition = 'before',
  } = props

  return (
    <div className="flex justify-center">
      {oldPrice && (
        <div
          className={cn('flex text-bodi-gray-disabled', {
            'flex-row-reverse': symbolPosition === 'after',
          })}
        >
          <span
            className={cn('gap-1 font-semibold lg:pt-1', {
              'text-body-sm': size === 'small',
              'text-body-xl': size === 'large',
            })}
          >
            {currencySymbol}
          </span>
          <span
            className={cn('line-through decoration-2', {
              'text-heading-display-3': size === 'small',
              'text-heading-display-2': size === 'large',
            })}
          >
            {oldPrice}
          </span>
        </div>
      )}
      <span
        className={cn('self-end pr-2 pl-0.5 font-medium text-bodi-gray-disabled lg:pb-0.5', {
          'text-body-sm pb-0.5': size === 'small',
          'text-body-xl': size === 'large',
        })}
      >
        {oldPriceSuffix}
      </span>
      {newPrice && (
        <div className={cn('flex', { 'flex-row-reverse': symbolPosition === 'after' })}>
          <span
            className={cn('gap-1 font-semibold lg:pt-1', {
              'text-body-sm': size === 'small',
              'text-body-xl': size === 'large',
            })}
          >
            {currencySymbol}
          </span>
          <span
            className={cn('', {
              'text-heading-display-3': size === 'small',
              'text-heading-display-2': size === 'large',
            })}
          >
            {newPrice}
          </span>
        </div>
      )}
      {newPriceSuffix && (
        <span
          className={cn('self-end pl-0.5 font-medium lg:pb-0.5', {
            'text-body-sm pb-0.5': size === 'small',
            'text-body-xl': size === 'large',
          })}
        >
          {newPriceSuffix}
        </span>
      )}
    </div>
  )
}
